import { render } from "./FilaSenha.vue?vue&type=template&id=335ca65d"
import script from "./FilaSenha.vue?vue&type=script&lang=js"
export * from "./FilaSenha.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__